export default __webpack_public_path__ + "static/media/ILUSTRACIONES_06.760d8a48.png";